import React, {useState} from 'react'
import Breadcrumb, {BreadcrumbType} from '../../components/Breadcrumb'
import {
  AssetsBox,
  AssetTitle,
  IconsBox,
  LeftBox,
  RightBox,
  TimeBox,
} from '../VideoPage/styles'
import AssetsSidenav from '../../components/AssetsSidenav'
import ProvenProcess from '../../../images/icons/new-dashboard/proven-process-icon.svg'
import {getDivisionDetails} from '../../../constants/divisions'
import {QuizBox} from './styles'
import {StudyGuide} from '../../../redux/studyGuides'
import QuizQuestions from '../../../components/QuizQuestions'
import {Helmet} from 'react-helmet'
import {useWindowDimensions} from '../../../hooks/useWindowDimensions'

type Props = {
  studyGuide?: StudyGuide
  studyDay?: string
  quizId?: string
}

const View = ({studyGuide, studyDay, quizId}: Props) => {
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [attemptStarted, setAttemptStarted] = useState(false)
  const {isMobile} = useWindowDimensions()

  const [isExpanded, setIsExpanded] = useState(isMobile ? false : true)

  const breadcrumbs: BreadcrumbType[] = [
    {
      title: studyGuide?.courseTitle ?? '',
      url: `/study-guide/${studyGuide?.id}`,
    },
    {
      title: `Day ${studyDay}`,
      url: `/study-guide/${studyGuide?.id}`,
    },
  ]

  const division = getDivisionDetails(studyGuide?.abbreviation ?? null)

  const currentAsset = studyGuide?.assets
    ? studyGuide.assets[0].quiz?.find(q => q.id === quizId)
    : undefined

  const getNextUrl = () => {
    return `/study-guide/${studyGuide?.id}`
  }

  return (
    <>
      <Helmet>
        <title>{`${currentAsset?.assetTitle} | Black Spectacles`}</title>
      </Helmet>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <AssetsBox>
        <LeftBox $isExpanded={isExpanded}>
          <AssetsSidenav
            currentAssetId={quizId}
            studyGuide={studyGuide}
            studyDay={Number(studyDay)}
            isExpanded={isExpanded}
            onChangeIsExpanded={(value: boolean) => setIsExpanded(value)}
          />
        </LeftBox>
        <RightBox>
          <IconsBox>
            <img src={division?.icon} alt={division?.name} />
            <img src={ProvenProcess} alt="Proven Process" />
          </IconsBox>
          {/* <ObjectiveText>
            Objective 1.1: Interpret the architect’s roles and responsibilities
            during pre-construction, based on delivery method.
          </ObjectiveText> */}
          <AssetTitle>{currentAsset?.assetTitle}</AssetTitle>
          {attemptStarted &&
          currentQuestion < (currentAsset?.questions ?? 0) ? (
            <TimeBox>
              Question {currentQuestion + 1} of {currentAsset?.questions}
            </TimeBox>
          ) : (
            <TimeBox>{currentAsset?.questions} questions</TimeBox>
          )}
          <QuizBox>
            <QuizQuestions
              lesson={currentAsset}
              currentQuestion={currentQuestion}
              setCurrentQuestion={setCurrentQuestion}
              setAttemptStarted={setAttemptStarted}
              isStudyGuide={true}
              getNextUrl={getNextUrl}
              quizId={quizId}
            />
          </QuizBox>
        </RightBox>
      </AssetsBox>
    </>
  )
}

export default View
